import { createContext, useContext, useState } from "react";
import { getUserInfo } from "src/api";
import { getAccessToken } from "src/utils";
import { IUserContext } from "./types";

const UserContext = createContext<IUserContext | undefined>({});

const UserProvider: React.FC = (props) => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const initUserInfo = async () => {
    try {
      setIsLoading(true);

      const accessToken = getAccessToken();

      if (!accessToken) {
        return;
      }

      const userInfoResponse = await getUserInfo(accessToken);

      //order is important, so we can redirect unlogged in users properly
      setData(userInfoResponse?.data ?? userInfoResponse); 
      setIsLoading(false);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <UserContext.Provider
      value={{
        data,
        isLoading,
        initUserInfo,
      }}
      {...props}
    />
  );
};

const useUser = (): IUserContext | undefined =>
  useContext<IUserContext | undefined>(UserContext);

export { UserProvider, useUser };
